import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  useSetRecoilState,
  useRecoilValue,
  useRecoilCallback,
  useRecoilState
} from 'recoil'
import BoxTestInfo from './step1/BoxTestInfo'
import BoxWinningMessage from './step1/BoxWinningMessage'
import ModalCheckupABTest from '../components/ModalCheckupABTest/ModalCheckupABTest'
import { Button, BUTTON_VARIANT_PRIMARY, Flex } from 'mailup-web-components'
import { abTestState, step1State } from '../recoil/state/abtest'
import { pageState, step1IsValidSate } from '../recoil/state/page'
import evalCondition from 'Helpers/evalCondition'
import { saveABTestConfigCallback } from '../recoil/callbacks/callbacks'
import { useHistory } from 'react-router'

const AbTestWizard1Step = () => {
  const intl = useIntl()
  const [{ id, step1 }, setAbTestState] = useRecoilState(abTestState)
  const { changeHistory } = useRecoilValue(step1State)

  const setPageState = useSetRecoilState(pageState)
  const step1IsValid = useRecoilValue(step1IsValidSate)

  const history = useHistory()
  const saveABTestConfig = useRecoilCallback(saveABTestConfigCallback, [])

  const onSuccess = () => {
    if (evalCondition('NOT uo:NOENQUEUE')) {
      setPageState(prev => ({
        ...prev,
        loading: false,
        wizardStep: prev.wizardStep + 1,
        numberOfStepEnabled: prev.numberOfStepEnabled + 1
      }))
      setAbTestState(prev => ({
        ...prev,
        step1: {
          ...prev.step1,
          step1IsDirty: false
        }
      }))
    } else {
      setAbTestState(prev => ({
        ...prev,
        step1: {
          ...prev.step1,
          step1IsDirty: false,
          changeHistory: '/messages/email/abtestlist'
        }
      }))
    }
  }

  useEffect(() => {
    changeHistory && history.push(changeHistory)
  }, [changeHistory])

  return (
    <>
      <ModalCheckupABTest abTestMessages={step1.abTestMessages} />
      <BoxTestInfo />
      <BoxWinningMessage />
      <Flex margin='0 0 20px 0' justifyContent='flex-end'>
        {/* margin a 20px da sommarsi a 20px del page-container per un totale di 40px */}
        <Button
          data-mu-test='abTestWizardStep1Continue'
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={() => saveABTestConfig(id, 1, onSuccess)}
          disabled={!step1IsValid}
        >
          {evalCondition('NOT uo:NOENQUEUE')
            ? intl.formatMessage({ id: 'Load.MailupCommon.Continue' })
            : intl.formatMessage({ id: 'Load.Common.Save' })}
        </Button>
      </Flex>
    </>
  )
}

export default AbTestWizard1Step
